import { render, staticRenderFns } from "./CardLayoutHeader.vue?vue&type=template&id=584c4c91&scoped=true&lang=html"
import script from "./CardLayoutHeader.vue?vue&type=script&lang=js"
export * from "./CardLayoutHeader.vue?vue&type=script&lang=js"
import style0 from "./CardLayoutHeader.vue?vue&type=style&index=0&id=584c4c91&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c4c91",
  null
  
)

export default component.exports